import React, { useState } from "react"
import { Map, GoogleApiWrapper, Marker } from "google-maps-react"

const mapStyles = {
  width: "65%",
  height: "40%",
}
const GoogleMap = props => {
  // const [stores] = useState(
  //   props.renderData.property_aggregate.neighborhood?.geo_shape || []
  // )
  // const [state, setState] = useState([])
  // var cords = []
  // function displayLine() {
  //   if (stores.length !== 0) {
  //     return props.renderData.property_aggregate.neighborhood?.geo_shape.map(
  //       e =>
  //         setState(prevState => [
  //           ...prevState,
  //           { lat: e.latitude, lng: e.longitude },
  //         ])
  //     )
  //   } else {
  //     return
  //   }
  // }
  // props.renderData.property_aggregate.property.location.geo.longitude,
  // props.renderData.property_aggregate.property.location.geo.latitude,
  // console.log(state, "state")
  // useEffect(() => {
  //   displayMarkers()
  //   displayLine()
  // }, [
  //   stores,
  //   props.longitude,
  //   props.renderData.property_aggregate.property.location.geo.latitude,
  // ])
  // const triangleCoords = [
  //   { lat: 48.734400519239, lng: 2.2911567710437 },
  //   { lat: 48.6534400519239, lng: 2.4411567710437 },
  //   { lat: 48.634400519239, lng: 2.4511567710437 },
  //   { lat: 48.854400519239, lng: 2.4211567710437 },
  // ]
  // function displayMarkers() {
  //   if (stores.length !== 0) {
  //     return stores.map((store, index) => {
  //       return (
  //         <Marker
  //           key={index}
  //           id={index}
  //           position={{
  //             lat: store.latitude,
  //             lng: store.longitude,
  //           }}
  //           onClick={() => console.log("You clicked me!")}
  //         />
  //       )
  //     })
  //   } else {
  //     return
  //   }
  // }
  //   var bounds = new props.google.maps.LatLngBounds();
  // for (var i = 0; i < stores.length; i++) {
  //   bounds.extend(stores[i]);
  // }
  //   props.renderData.property_aggregate.property.location.geo.latitude
  //   props.renderData.property_aggregate.property.location.geo.longitude||
  return (
    <div className="house-map" style={{width: "100%",height:"100%",minHeight:"300px",position:"relative"}}>
    {!props.google?<div className="map-loading"><p>loading...</p></div>:
    <Map
      className="house-location-map"
      google={props.google}
      zoom={12}
      style={props.housingDetails?mapStyles:null}
      initialCenter={{
        lat:
          props.latitude ||0,
        lng:
          props.longitude ||0,
      }}
    >
    <Marker
    key={props.latitude}
    id={props.latitude}
    position={{
      lat: props.latitude,
      lng:  props.longitude,
    }}
    onClick={() => console.log("You clicked me!")}
  />
      {/*displayMarkers()*/}
      {/*state.length !== 0 && (
        <Polyline
          path={state}
          strokeColor="#0b5da8"
          strokeOpacity={0.8}
          strokeWeight={2}
        />
      )*/}
    </Map>}</div>
  )
}

export default GoogleApiWrapper({apiKey: process.env.GOOGLE_LOCATION_API_KEY})(GoogleMap)
